<form [formGroup]="userDetails" id="user-details" (ngSubmit)=onSubmit(userDetails)>
    <div class="d-flex flex-column justify-content-center text-center flex-column m-step-wrapper1 container" 
    [ngClass]="{'first-question' : !prevQID}">
        <questions-manager [(editQid)]="qID" 
        [visibleQids]="visibleQids" 
        [(editQuestion)]="editQuestion" 
        (editQuestionChange)="editQuestionChange($event)">
            <!--name-->
            <question [qID]="'1'">
                <div>
                    <div *ngIf="isAdvisor"><h1>{{ 'USER_DETAILS.Q1.QUESTION_ADVISORS' | translate }}</h1><br><br></div>
                    <h3>{{ 'USER_DETAILS.Q1.QUESTION' | translate }}</h3>
                    <div class="d-flex flex-column flex-md-row justify-content-center text-center">
                        <div class="mx-1 form-group">
                            <input type="text" class="form-control m-form-control2" placeholder="{{ 'USER_DETAILS.Q1.INPUT1_PH' | translate }}" formControlName="firstName">
                            <div class="form-text m-error" *ngIf="userDetails.get('firstName').hasError('required') && submitted">
                                {{ 'USER_DETAILS.Q1.REQUIRED1' | translate }}
                            </div>
                            <div class="form-text m-error" *ngIf="userDetails.get('firstName').hasError('pattern') && submitted">
                                {{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}
                            </div>
                        </div>
                        <div class="mx-1 form-group">
                            <input type="text" class="form-control m-form-control2" placeholder="{{ 'USER_DETAILS.Q1.INPUT2_PH' | translate }}" formControlName="lastName">
                            <div class="form-text m-error" *ngIf="userDetails.get('lastName').hasError('required') && submitted">
                                {{ 'USER_DETAILS.Q1.REQUIRED2' | translate }}
                            </div>
                            <div class="form-text m-error" *ngIf="userDetails.get('lastName').hasError('pattern') && submitted">
                                {{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <button type="submit" 
                                class="btn btn-primary" 
                                [ngClass]="{'m-valid' : userDetails.valid && qID=='1'}">
                        {{"COMMON.PROCEED"|translate}}
                    </button>
                    </div>
                </div>
            </question>
           <!--tz-->
            <question [qID]="'2'">
                <div>
                    <h3>{{"USER_DETAILS.Q2.QUESTION"|translate}}</h3>
                    <div class="">
                    <input class="form-control m-form-control" type="tel" maxlength="9" placeholder="{{'USER_DETAILS.Q2.PH1'|translate}}" formControlName="idNumber">
                        <div>
                            <div class="form-text m-error" *ngIf="userDetails.get('idNumber').hasError('required') && submitted">
                                {{ 'COMMON.FIELD_REQUIRED' | translate }}
                            </div>
                            <div class="form-text m-error" *ngIf="userDetails.get('idNumber').hasError('invalidId') && !userDetails.get('idNumber').hasError('required') && submitted">
                                {{ 'COMMON.ID_PATTERN_ERROR' | translate }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center">
                    <button type="submit" class="btn btn-primary"  
                    [ngClass]="{'m-valid' : userDetails.valid && qID=='2'}">{{"COMMON.PROCEED"|translate}}</button>
                </div>
            </question>
            <!--phone-->
            <question [qID]="'3'">
                <div>
                    <h3>{{"USER_DETAILS.Q3.QUESTION"|translate}}</h3>
                    <inner-tooltip [qTitle]="'USER_DETAILS.Q3.TOOLTIP'|translate"
                                    [text]="'USER_DETAILS.Q3.TOOLTIP_TEXT'|translate"
                                    class="m-inner-popover"></inner-tooltip>					
                </div>
                <div>
                    <div class="d-flex justify-content-center">
                        <div class="m-1">
                            <phone-number [customClass]="'user-details'" formControlName="phoneNumber" [(isMobile)]="isMobilePhone" (change)="updateValidators($event.target.value)"
                                [attr.aria-label]="'HELP_DIALOG.PHONE_NUMBER_PC' | translate" [attr.aria-invalid]="!userDetails.get('phoneNumber').valid &&  submitted">
                            </phone-number>
                            <div class="form-text m-error" *ngIf="userDetails.get('phoneNumber').hasError('minlength') && submitted">
                                {{ 'COMMON.PHONE_MIN_CHARS' | translate }}
                            </div>
                            <div class="form-text m-error" *ngIf="userDetails.get('phoneNumber').hasError('required') && submitted">
                                {{ 'COMMON.FIELD_REQUIRED' | translate }}
                            </div>
                            <div class="form-text m-error" *ngIf="userDetails.get('phoneNumber').hasError('pattern') && submitted">
                                {{ 'COMMON.PHONE_NUM_PATTERN_ERROR' | translate }}
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <button type="submit" class="btn btn-primary" [ngClass]="{'m-valid' : userDetails.valid && qID=='3'}">{{"COMMON.PROCEED"|translate}}</button>
                    </div>
                </div>
            </question>
            <!--email-->
            <question [qID]="'4'">
                <div>
                    <h3>{{"USER_DETAILS.Q4.QUESTION"|translate}}</h3>
                    <div class="form-group">
                        <input type="text" formControlName="email"
                               placeholder="{{'USER_DETAILS.Q4.PH1'|translate}}"
                               class="form-control m-form-control"
                               [attr.aria-label]="'USER_DETAILS.Q4.PH1'|translate" />
                        <div class="form-text m-error"
                             *ngIf="userDetails.get('email').hasError('pattern') && submitted">
                            {{ 'COMMON.EMAIL_PATTERN_ERROR' | translate }}
                        </div>
                        <div class="form-text m-error"
                             *ngIf="userDetails.get('email').hasError('required') && submitted">
                            {{ 'COMMON.FIELD_REQUIRED' | translate }}
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <button type="submit" class="btn btn-primary" 
                                [ngClass]="{'m-valid' : userDetails.valid && qID=='4'}">
                                {{"COMMON.PROCEED"|translate}}
                        </button>
                    </div>
                </div>
                					
            </question>
         
        </questions-manager>
    </div>
</form>


// WEBPACK FOOTER //
// ./src/app/user-details/user-details.component.html